import Checkbox from 'antd/lib/checkbox/Checkbox'
import styled from 'styled-components'
import Button from '../Button'

export const TableWrapper = styled.div`
  width: 550px;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 6px 0px #7b61ff26;
  border: 1px solid #d6dbf7;
`

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  border: ${({ selected }) =>
    selected ? '2px solid #3249d7' : '1px solid #E0E0E0'};
  border-radius: 10px;
  background-color: #fff;
  color: #000000;
  cursor: pointer;
  font-size: 14px;
  height: 38px;
  & + & {
    margin-left: 10px;
  }
`
export const StatusContainer = styled.span`
  display: inline-flex;
  align-items: center;
  flex-direction: column;
`

export const StatusGroup = styled.span`
  display: inline-flex;
  align-items: center;
  margin-bottom: ${({ marginBottom }) => marginBottom || '2px'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
`

export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox + span {
    padding-left: 12px;
    font-size: 12px;
    font-weight: ${props => (props.fontWeight ? props.fontWeight : '400')};
    color: #808697;
  }
  .ant-checkbox-inner {
    width: 12px !important;
    height: 12px !important;
    border-radius: 3px !important;
  }
  .ant-checkbox-input {
    margin-bottom: 10px !important;
  }
  &.ant-checkbox-wrapper {
    align-items: flex-start !important;
    color: #808697;
  }
  .ant-checkbox {
    margin-top: 2px !important;
    padding-right: 10px;
    padding-left: 20px;
  }
`

export const StatusDot = styled.span`
  width: 8px;
  height: 8px;
  background-color: ${props =>
    props.ruleAlreadySet
      ? '#FF4D00'
      : props.inDraft
      ? '#A9A9A9'
      : 'transparent'};
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
`

export const StatusText = styled.span`
  font-size: 12px;
  color: ${props =>
    props.ruleAlreadySet ? '#000000' : props.inDraft ? '#000000' : 'black'};
`

export const StatusWrapper = styled.div`
  display: flex;
  margin-top: 5px;
  flex-direction: column;
`
export const CustomCheckBox = styled(Checkbox)`
  color: ${({ color }) => color || '#808697'};
  display: flex;
  align-items: center;
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #3249d7;
    border-color: #3249d7;
  }
  .ant-checkbox-wrapper {
    color: #808697;
  }
  .ant-checkbox + span {
    text-align: left;
    color: ${({ isHeader, isDraft, isExistingRule }) =>
      isHeader
        ? '#808697'
        : isDraft
        ? '#ADADAD'
        : isExistingRule
        ? '#FF4C00'
        : '#000'};
    padding-left: 1rem;
    font-size: 12px;
    font-weight: ${props => (props?.isHeader ? '500' : '400')};
    text-transform: capitalize;
  }

  .ant-checkbox-inner {
    border-radius: 4px;
    width: 15px;
    height: 15px;
  }
  .ant-checkbox {
    top: inherit;
  }
`

export const CustomDegreeCheckbox = styled(Checkbox)`
  font-family: Plus Jakarta Sans;
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #3249d7;
    border-color: #3249d7;
  }
  .ant-checkbox-inner {
    border-radius: 4px;
    width: 15px;
    height: 15px;
  }
  .ant-checkbox + span {
    text-align: left;
    color: ${props => (props?.isHeader ? '#808697' : '#000')};
    padding-left: 1rem;
    font-size: 12px;
    font-weight: ${props => (props?.isHeader ? '500' : '700')};
    text-transform: capitalize;
  }
  color: ${({ color }) => color || '#000'};
  padding-left: ${({ paddingLeft }) => paddingLeft || '0'};
  padding-right: ${({ paddingRight }) => paddingRight || '0'};
`

export const ApplyButton = styled.button`
  width: 126px;
  margin-left: 400px;
  font-size: 16px;
  font-weight: 30px;
  text-align: Center;
  cursor: pointer;
  font: Plus Jakarta Sans;
  color: #3249d7;
  align: Center;
  // width: 20px;
  height: 40px;
  // padding: 9px 20px 9px 20px;
  gap: 7px;

  border-radius: 8px;
  // border: 1px #d9d9d9;
  border: 1px solid #d1d5db;
  opacity: 0px;
  // padding-right: 30px;
  background-color: #fff;
  position: relative;
  right: 20px;
`
export const TableContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: Center;
  margin-bottom: 20px;
`
export const TableData = styled.td`
  color: ${({ isHeader, isDraft, isExistingRule }) =>
    isHeader
      ? '#808697'
      : isDraft
      ? '#ADADAD'
      : isExistingRule
      ? '#FF4C00'
      : '#000'};

  padding-left: ${({ paddingLeft }) => paddingLeft || '0'}!important;
`
export const ButtonContainer = styled.div`
  padding-top: 10px;
`

export const Apply = styled(Button.Secondary)`
  width: 100px;
  margin-left: 410px;
`
